import { render, staticRenderFns } from "./GridSQTV.vue?vue&type=template&id=3a0afcb6&scoped=true"
import script from "./GridSQTV.vue?vue&type=script&lang=ts&setup=true"
export * from "./GridSQTV.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./GridSQTV.vue?vue&type=style&index=0&id=3a0afcb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0afcb6",
  null
  
)

export default component.exports